import * as downloadActions from './actions';
import downloadEpics from './epics';
import reducer from './reducers';
import * as downloadSelectors from './selectors';
import * as downloadTypes from './types';

export { downloadActions, downloadEpics, downloadSelectors, downloadTypes };

export default reducer;
